/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { policyControllerCreate } from '../fn/policy/policy-controller-create';
import { PolicyControllerCreate$Params } from '../fn/policy/policy-controller-create';
import { policyControllerDelete } from '../fn/policy/policy-controller-delete';
import { PolicyControllerDelete$Params } from '../fn/policy/policy-controller-delete';
import { policyControllerFindById } from '../fn/policy/policy-controller-find-by-id';
import { PolicyControllerFindById$Params } from '../fn/policy/policy-controller-find-by-id';
import { policyControllerSearch } from '../fn/policy/policy-controller-search';
import { PolicyControllerSearch$Params } from '../fn/policy/policy-controller-search';
import { policyControllerUpdate } from '../fn/policy/policy-controller-update';
import { PolicyControllerUpdate$Params } from '../fn/policy/policy-controller-update';
import { PolicyDto } from '../models/policy-dto';
import { PolicySearchResponseDto } from '../models/policy-search-response-dto';

@Injectable({ providedIn: 'root' })
export class PolicyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `policyControllerSearch()` */
  static readonly PolicyControllerSearchPath = '/api/policy';

  /**
   * 약관 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `policyControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerSearch$Response(params: PolicyControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PolicySearchResponseDto>> {
    return policyControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `policyControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerSearch(params: PolicyControllerSearch$Params, context?: HttpContext): Observable<PolicySearchResponseDto> {
    return this.policyControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PolicySearchResponseDto>): PolicySearchResponseDto => r.body)
    );
  }

  /** Path part for operation `policyControllerCreate()` */
  static readonly PolicyControllerCreatePath = '/api/policy';

  /**
   * 약관 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `policyControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  policyControllerCreate$Response(params: PolicyControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return policyControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `policyControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  policyControllerCreate(params: PolicyControllerCreate$Params, context?: HttpContext): Observable<boolean> {
    return this.policyControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `policyControllerFindById()` */
  static readonly PolicyControllerFindByIdPath = '/api/policy/{id}';

  /**
   * 약관 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `policyControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerFindById$Response(params: PolicyControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PolicyDto>> {
    return policyControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `policyControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerFindById(params: PolicyControllerFindById$Params, context?: HttpContext): Observable<PolicyDto> {
    return this.policyControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PolicyDto>): PolicyDto => r.body)
    );
  }

  /** Path part for operation `policyControllerDelete()` */
  static readonly PolicyControllerDeletePath = '/api/policy/{id}';

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `policyControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerDelete$Response(params: PolicyControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return policyControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `policyControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  policyControllerDelete(params: PolicyControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.policyControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `policyControllerUpdate()` */
  static readonly PolicyControllerUpdatePath = '/api/policy/{id}';

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `policyControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  policyControllerUpdate$Response(params: PolicyControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return policyControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `policyControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  policyControllerUpdate(params: PolicyControllerUpdate$Params, context?: HttpContext): Observable<boolean> {
    return this.policyControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
